import { render, staticRenderFns } from "./DNAMethylation.vue?vue&type=template&id=e23a6490&"
import script from "./DNAMethylation.vue?vue&type=script&lang=js&"
export * from "./DNAMethylation.vue?vue&type=script&lang=js&"
import style0 from "./DNAMethylation.vue?vue&type=style&index=0&id=e23a6490&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports